import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import {
  CheckboxField,
  FieldGroup,
  SelectField,
  TextField,
} from '../../../../components/form';
import { useIsAdmin } from '../../../../store';
import { getCurrencies } from '../../../../store/constants/currencies';
import Products from '../../../products/store/Products';
import Bundle from '../../store/Bundle';
import ProductSelectList from './ProductSelectList';

export default observer(function BundleGeneralPanel({
  bundle,
  products,
}: {
  bundle: Bundle;
  products: Products;
}) {
  const disableReadonlyFields = !bundle.isFullEditAllowed;
  // Bundle keys aren't public yet
  const isAdmin = useIsAdmin({ mode: 'any' });

  return (
    <form>
      <Grid container spacing={6}>
        <Grid item xs={6}>
          <TextField
            errorText={bundle.errors.name}
            label="Name"
            name="name"
            onBlur={bundle.handleBlur}
            onChange={bundle.handleChange}
            required
            value={bundle.name}
          />

          <TextField
            disabled={disableReadonlyFields}
            disabledTooltip={DISABLED_TOOLTIP}
            errorText={bundle.errors.sku}
            helperText="lowercase with no spaces or unusual symbols"
            label="SKU"
            name="sku"
            onBlur={bundle.handleBlur}
            onChange={bundle.handleChange}
            required
            value={bundle.sku}
          />

          <FieldGroup>
            <TextField
              disabled={disableReadonlyFields}
              disabledTooltip={DISABLED_TOOLTIP}
              errorText={bundle.errors.price}
              label="Price"
              name="price"
              onBlur={bundle.handleBlur}
              onChange={bundle.handleChange}
              required
              sx={{ width: 80 }}
              type="number"
              value={bundle.price}
            />

            <SelectField
              disabled={disableReadonlyFields}
              disabledTooltip={DISABLED_TOOLTIP}
              errorText={bundle.errors.currency}
              label="Currency"
              name="currency"
              onBlur={bundle.handleBlur}
              onChange={bundle.handleChange}
              options={getCurrencies()}
              required
              sx={{ width: 80 }}
              value={bundle.currency}
            />
          </FieldGroup>

          {isAdmin && (
            <CheckboxField
              helperText="Customers get one key for the whole bundle. Affects only new keys."
              label="Use a single bundle key"
              name="useBundleKey"
              onChange={bundle.handleChange}
              value={bundle.useBundleKey}
            />
          )}
        </Grid>

        <Grid item xs={6}>
          <ProductSelectList
            label="Choose products included in the bundle"
            onChange={(value) => bundle.changeProductsIds(value)}
            productList={products}
            value={bundle.productsIds}
          />
        </Grid>
      </Grid>
    </form>
  );
});

const DISABLED_TOOLTIP =
  'The field cannot be changed after publishing. ' +
  'Please contact Pulse Admin if you wish to change it.';
